module.exports = __webpack_public_path__ + "models/tutor2.a26d7fb.txt";